import { useContext, useState } from "react";
import IdCell from "layouts/articles/article-list/components/IdCell";
import DefaultCell from "layouts/articles/article-list/components/DefaultCell";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { NavLink } from "react-router-dom";
import { DataContext } from "context/dataContext";
import SnackbarAlert from "components/SnackbarAlert";
import DeleteConfirmationPopover from "components/DeleteConfirmationPopover";

const dataTableData = {
  columns: [
    {
      Header: "ID",
      accessor: "id",
      width: 100,
      link: "/articles/edit-article/",
      linkByID: true,
      Cell: ({ value }) => <IdCell id={value.toUpperCase()} />,
    },
    {
      Header: "Title",
      accessor: "title",
      link: "/articles/edit-article/",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Slug",
      accessor: "slug",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Category",
      accessor: "category",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Type",
      accessor: "type",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Read Time",
      accessor: "read_time",
      linkByID: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Actions",
      accessor: "actions",
      width: 10,
      align: "right",
      Cell: ({ row }) => {
        const { deleteSingleArticleApi } = useContext(DataContext);

        return (
          <>
            <MDBox display="flex" gap={2}>
              <MDButton
                size="small"
                variant="gradient"
                color="primary"
                component={NavLink}
                to={`/articles/edit-article/${row.original.id}`}
              >
                Edit
              </MDButton>
              <DeleteConfirmationPopover
                heading="are you sure?"
                buttonText="Delete"
                DeleteFunction={() => {
                  deleteSingleArticleApi(row.original.id);
                }}
              />
            </MDBox>
          </>
        );
      },
    },
  ],

  rows: [],
};

export default dataTableData;
